import { Container, Flex, Stack, Text } from '@chakra-ui/react';
import { MainLogoSmall } from '../../../assets/icons';
import { StackToStaticPages } from '../../Links/StackToStaticPages';

export const AuthFooter = () => {
  return (
    <Container maxW={800} mt={{ base: 12, '2xl': '10vh' }} pb={[5, 10]}>
      <Flex justifyContent={['center', 'space-between']} flexDir={['column', 'row']} alignItems='center'>
        <Stack spacing={[3, 7]} direction={['column', 'row']} alignItems={['center', 'flex-end']}>
          <MainLogoSmall />
          <Text color='whiteAlpha.600' fontSize={[12, 14]} lineHeight='100%'>
            © {new Date().getFullYear()} Sparkx
          </Text>
        </Stack>

        <StackToStaticPages />
      </Flex>
    </Container>
  );
};
